module.exports = __webpack_public_path__ + "img/Newbie_Sword_04_Classic.d3045f0a.png";